export enum IntegrationCategoryEnum {
  DEVELOPER_TOOLS = 'DEVELOPER_TOOLS',
  COMMUNICATION = 'COMMUNICATION',
  PRODUCTIVITY = 'PRODUCTIVITY',
  HARDWARE = 'HARDWARE',
  SYSTEM = 'SYSTEM',
}
